define('app-Agents/modules/forms/settings',[],function () {
    return {
        container: ".agentForm",
        loginContainer: "#agentLoginContainer",
        registrationContainer: "#agentRegistrationContainer",
        forgotPasswordContainer: "#forgotPasswordContainer",
        resetPasswordContainer: "#resetPasswordContainer",
        forgotEmailContainer: "#forgotEmailContainer",
        manageBookingContainer: '#agentManageBookingContainer',
        elements: {
            agentAbtaNumber: "#agentAbtaNumber",
            consultantFirstName: "#agentConsultantFirstName",
            consultantSurname: "#agentConsultantSurname",
            consultantTelephoneNumber: "#agentConsultantContactNumber",
            emailAddress: "#agentEmailAddress",
            bookingid: "#bookingId",
            leadPassengerSurname : '#leadPassengerSurname'
        }
    };
});
